import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, CardHeader, Col, Row, Button, Table } from 'reactstrap';
import { useNavigate } from 'react-router-dom';
import { MdAdd, MdEdit } from 'react-icons/md';

// components
import Page from '../components/Page';
// lib
import { dateTimeFormat } from '../lib/date';
// My components
import ReactDataTable from '../mycomponents/ReactDataTable';
// api
import { getAuthorList } from '../api/admin';

const AuthorList = () => {

    const title = "Author List";
    const navigate = useNavigate();
    const columns = [
        {
            key: "name",
            text: "Name",
            className: "name",
            align: "left",
            sortable: false
        },
        {
            key: "role",
            text: "Role",
            className: "role",
            align: "left",
            sortable: false
        },
        {
            key: "createdAt",
            text: "Created At",
            className: "createdAt",
            align: "left",
            sortable: false,
            cell: ({ createdAt }) => {
                return dateTimeFormat(createdAt)
            }
        },
        {
            key: "action",
            text: "Action",
            className: "action",
            align: "left",
            sortable: false,
            cell: state => {
                return (
                    <Button color="secondary" onClick={() => navigate('/author-edit', { state })}>
                        <MdEdit />
                    </Button>
                )
            }
        }
    ];


    // state
    const [data, setData] = useState([]);
    const [count, setCount] = useState(0);
    const [loader, setLoader] = useState(false);
    const [pagination, setPagination] = useState({ page: "", limit: "", search: "" });
    // const { page, limit, search } = pagination;

    const fetchData = useCallback(async () => {
        try {
            setLoader(true);
            const { status, result } = await getAuthorList(pagination);
            setLoader(false);
            if (status === true) {
                setData(result.data)
                setCount(result.count)
            }
        } catch (err) { }
    }, [pagination])

    useEffect(() => {
        fetchData()
    }, [pagination, fetchData])

    return (
        <Page
            title={title}
            breadcrumbs={[{ name: title, active: true }]}
            className="TablePage"
        >
            <Row>
                <Col>
                    <Card className="mb-3">
                        <CardHeader className="d-flex align-items-center justify-content-between">
                            <span>Author List</span>
                            <Button color="primary" onClick={() => navigate('/author-add')}><MdAdd />Add</Button>
                        </CardHeader>
                        <CardBody>
                            <Table responsive={false}>
                                <ReactDataTable
                                    columns={columns}
                                    records={data}
                                    count={count}
                                    loader={loader}
                                    setPagination={setPagination}
                                />
                            </Table>
                        </CardBody>
                    </Card>
                </Col>
            </Row>
        </Page>
    );
};

export default AuthorList;